import React from "react";
import { Drawer, IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../../theme/tokens";

const useStyles = makeStyles(() => ({
  drawerPaper: {
    width: 500,
    height: "99%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden", // Prevent the paper itself from scrolling
    marginTop: "1%",
    borderTopLeftRadius: tokens.radius.md,
    borderLeft: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    boxShadow: "none",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: `${tokens.space[2]} ${tokens.space[3]}`,
    borderBottom: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
  },
  drawerTitle: {
    fontSize: "1.25em",
    fontWeight: 600,
    color: tokens.color.text.primary,
  },
  contentWrapper: {
    flex: 1, // This takes up all available middle space
    display: "flex",
    flexDirection: "column",
    overflow: "hidden", // Pass control to the child
  },
  resetSection: {
    padding: `${tokens.space[2]} ${tokens.space[4]}`,
    borderBottom: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    backgroundColor: tokens.color.surface.sunken,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  resetLink: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
    color: tokens.color.text.secondary,
    fontSize: "0.675rem",
    fontWeight: 500,
    textDecoration: "none",
    margin: "6px 0px 0px 0px",
    "&:hover": {
      fontWeight: 600,
      textDecoration: "underline",
    },
  },
}));

interface RightDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const RightDrawer: React.FC<RightDrawerProps> = ({
  open,
  onClose,
  title,
  children,
}) => {
  const classes = useStyles();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <div className={classes.drawerHeader}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <span className={classes.drawerTitle}>{title}</span>
        </div>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.contentWrapper}>{children}</div>
    </Drawer>
  );
};

export default RightDrawer;
